
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/accessories/[...slug]",
      function () {
        return require("private-next-pages/accessories/[...slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/accessories/[...slug]"])
      });
    }
  